import { useEffect } from "react";
import { useTranslation } from "../i18n";

const APP_NAME = "Portal";

// Sets the browser tab title to "Portal - {translated key}".
// Reacts to language changes so the tab updates on EN/PL toggle.
// If the key has no translation, t() returns the key itself, which
// is fine for the few pages that don't have a dedicated i18n entry.
export const usePageTitle = (titleKey: string) => {
    const { t, language } = useTranslation();
    useEffect(() => {
        document.title = `${APP_NAME} - ${t(titleKey)}`;
    }, [titleKey, language, t]);
};

export default usePageTitle;
